<template>
	<div class="lillan-reviews">
		<div class="lillan-reviews__title">
			<h2>{{ context.translations.reviews }}</h2>
		</div>
		<div class="show-list">
			<div class="row">
				<div class="col-md-4" v-for="review in context.reviews">
					<div class="show-list__item">
						<div class="show-list__title">
							<h3>{{ context.translations.review }}</h3>
						</div>
						<div class="show-list__subtitle">
							{{ review.date }} &middot;
							{{ review.critic }} &middot;
							{{ review.publication }}
						</div>
						<div class="show-list__caption" v-html="review.review"></div>
						<div class="show-list__button">
							<button class="lillan-button-small" v-on:click="showReview(review)">
								{{ context.translations.read_more }}
							</button>
						</div>
					</div>
				</div>
			</div>
			<MountingPortal mountTo="body" name="source" append>
				<transition name="side">
					<div class="lillan-menu-sidebar" v-if="modalOpen" v-on:click.self="modalOpen = false">
						<div class="lillan-menu-sidebar__inner">
							<div class="lillan-menu-sidebar__h1-container">
								<h1 class="lillan-menu-sidebar__h1">{{ context.translations.review }}</h1>
							</div>

							<div class="lillan-menu-sidebar__meta">
								{{ currentReview.date }} &middot;
								{{ currentReview.critic }} &middot;
								{{ currentReview.publication }}
							</div>

							<div class="wysiwyg" v-html="currentReview.full_review"></div>
							<button class="lillan-menu-sidebar__close-button"
								v-html="require('!raw-loader!../../images/sidebar-close-icon.svg').default"
								v-on:click="modalOpen = false">
							</button>
						</div>
					</div>
				</transition>
				<transition name="fade">
					<div class="lillan-menu-shade"
						v-if="modalOpen"
					></div>
				</transition>
			</MountingPortal>
		</div>
	</div>
</template>

<script>
export default {
	props: [ 'context' ],
	data: function() {
		return {
			modalOpen: false,
			currentReview: null,
		};
	},
	methods: {
		showReview(review) {
			this.currentReview = review;

			console.log('this.currentReview', this.currentReview);

			this.modalOpen = true;
		},
	},
};
</script>
